/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Common_Sign_Reset_Link_Sent_DescriptionInputs */

const en_common_sign_reset_link_sent_description = /** @type {(inputs: Common_Sign_Reset_Link_Sent_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`If an account exists for ${i?.email}, we've sent a link to reset your password. The link will expire in 1 hour.`)
};

const zh_common_sign_reset_link_sent_description = /** @type {(inputs: Common_Sign_Reset_Link_Sent_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`如果 ${i?.email} 已注册账号，我们已发送密码重置链接，请在 1 小时内完成重置。`)
};

/**
* | output |
* | --- |
* | "If an account exists for {email}, we've sent a link to reset your password. The link will expire in 1 hour." |
*
* @param {Common_Sign_Reset_Link_Sent_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_reset_link_sent_description = /** @type {((inputs: Common_Sign_Reset_Link_Sent_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Reset_Link_Sent_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_reset_link_sent_description(inputs)
	return zh_common_sign_reset_link_sent_description(inputs)
});
export { common_sign_reset_link_sent_description as "common.sign.reset_link_sent_description" }